import {IconButton, Stack, Typography} from "@mui/joy";
import Logo from "../assets/icon_app_rounded.png";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {Logout} from "@mui/icons-material";
import React, {useContext} from "react";
import {Link} from "react-router-dom";
import {LANGUAGES} from "../utils/Utils";
import {useTranslation} from "react-i18next";
import {AuthContext, AUTHSTATES} from "../utils/AuthProvider";

export function Navbar() {
    const { i18n, t } = useTranslation();
    const {authState} = useContext(AuthContext)

    function changeLang(code: string) {
        i18n.changeLanguage(code);
    }

    return (
        <Stack sx={{width:"100vw", py:2, position: 'fixed', top:0}} direction="row" justifyContent="space-evenly" alignItems="center">
            <Stack spacing={2} direction="row" justifyContent="center" alignItems="center"
                   onClick={() => { window.location.href = "https://cinefx.danieledigregorio.it"; }}
                   sx={{ cursor: "pointer", }}
            >
                <img src={Logo} alt="Logo" width={50} height={50}/>
                <Typography level="h3">CineFX</Typography>
            </Stack>
            <Stack spacing={2} direction="row" justifyContent="center" alignItems="center">
                {
                    authState !== AUTHSTATES.LOGGEDOUT ?
                        <>
                            <Link to="/">
                                <Typography level="body-md">{t("account")}</Typography>
                            </Link>
                            <IconButton onClick={() => {
                                if(window.confirm("Effettuare il logout?")) {
                                    firebase.auth().signOut()
                                }
                            }}>
                                <Logout />
                            </IconButton>
                        </>
                        :
                        null
                }
                <IconButton onClick={() => {
                    if(i18n.language === LANGUAGES[1].code) {
                        changeLang(LANGUAGES[0].code)
                    } else {
                        changeLang(LANGUAGES[1].code)
                    }
                }}>
                    {
                        i18n.language === LANGUAGES[1].code ?
                            LANGUAGES[0].flag
                            :
                            LANGUAGES[1].flag
                    }
                </IconButton>
            </Stack>
        </Stack>
    )
}